const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

let isInitialized = false;
let hasWarnedMissingId = false;

const canUseBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';

const isEnabled = () => canUseBrowser() && Boolean(GA4_MEASUREMENT_ID);

const warnMissingId = () => {
  if (process.env.NODE_ENV === 'production' || hasWarnedMissingId) {
    return;
  }

  hasWarnedMissingId = true;
  // Helpful during local setup; silent in production.
  console.warn('GA4 disabled: missing REACT_APP_GA4_MEASUREMENT_ID');
};

const injectGtagScript = () => {
  const scriptId = 'ga4-gtag-script';
  if (document.getElementById(scriptId)) {
    return;
  }

  const script = document.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

export const initializeAnalytics = () => {
  if (isInitialized) {
    return true;
  }

  if (!isEnabled()) {
    warnMissingId();
    return false;
  }

  injectGtagScript();

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: false
  });

  isInitialized = true;
  return true;
};

const normalizeEventName = (eventName = '') => (
  String(eventName)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, '_')
    .replace(/^_+|_+$/g, '')
);

export const trackPageView = ({ path, title } = {}) => {
  if (!initializeAnalytics()) {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: path || `${window.location.pathname}${window.location.search}`,
    page_title: title || document.title,
    page_location: window.location.href
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!initializeAnalytics()) {
    return;
  }

  const normalizedName = normalizeEventName(eventName);
  if (!normalizedName) {
    return;
  }

  window.gtag('event', normalizedName, params);
};

